import { ROLE_MAESTRO } from "@/constants";

export default [
  {
    path: "/maestro/dashboard",
    name: "MaestroDashboard",
    component: () => import(/* webpackChunkName: "maestro-dashboard" */ "@/pages/Maestro/Dashboard/IndexView.vue"),
    meta: { auth: true, authorize: ROLE_MAESTRO }
  },
  {
    path: "/maestro/feedbacks",
    name: "MaestroFeedbacks",
    component: () => import(/* webpackChunkName: "maestro-feedbacks" */ "@/pages/Maestro/Feedbacks/IndexView.vue"),
    meta: { auth: true, authorize: ROLE_MAESTRO }
  }
]